/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_FreeInputs */

const en_booking_portal_free = /** @type {(inputs: Booking_Portal_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const pl_booking_portal_free = /** @type {(inputs: Booking_Portal_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatne`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Booking_Portal_FreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_free = /** @type {((inputs?: Booking_Portal_FreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_FreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_free(inputs)
	return en_booking_portal_free(inputs)
});